import { Validator } from '@vista-digital/validator';
import { fieldDisplayTextValidatorSchema } from '../../types/field-display-text';
export const radioGroupFieldDisplayTextValidatorSchema = {
    label: fieldDisplayTextValidatorSchema.label,
    requiredMessage: fieldDisplayTextValidatorSchema.requiredMessage
};
export const radioGroupFieldDisplayTextValidator = Validator.object(radioGroupFieldDisplayTextValidatorSchema);
